module.exports = __webpack_public_path__ + "static/week_week4_spot5-471099c9b1919ffa3a57375b149ae860.jpg";